import React, { Component } from 'react';
import { TextInput } from '../../../lib/components/textInput';
import { setDevicePayload } from "../../../testActions";
import { store } from "../../../testStore";
import { withRouter } from 'react-router-dom';
import { S } from '../../../routes/routes';

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

/* Result */
import Result from 'iotera-base/result'

/* Json */
import { isEmpty } from 'iotera-base/object';
import { safeDeepGet, safeDeepGetWithType, stringify } from 'iotera-base/json'

/* Redux */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { domainIsTenant as dit } from '../../../routes/routes'

/* Sagas Actions */
import { buildWBoundActions, buildWSelector } from '../../../redux/ducks'
import { actions as notificationActions } from '../../../redux/ducks/notification'

import { SubViewHeader } from '../../../lib/components/subHeader';
import { IoteraForm } from '../../../lib/components/form';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../../lib/components/callbackGlobal';

const EDIT = "EDIT";
const WKEY = 'DEVICE_INFO';
const INIT_INFO = "INIT_INFO";
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

const onError = (errors) => console.log("Ada", errors.length, "error yang harus diperbaiki");

const schema = {
  type: "object",
  required: ["store_mqtt_url", "store_mqtt_username", "store_mqtt_password"],
  properties: {
    store_mqtt_url: { type: "string" },
    store_mqtt_username: { type: "string" },
    store_mqtt_password: { type: "string" },
    store_mqtt_mode: { type: "string" },
    store_mqtt_details: { type: "string" },
  }
};

const uiSchema = {
  store_mqtt_url: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="store_mqtt_url"
          type="text"
          label="MQTT URL"
          placeholder="MQTT URL"
          className="custom"
          value={props.value}
          onError={onError}
          disabled
          required={props.required}
        />
      )
    },
    "ui:options": {
      label: false
    }
  },
  store_mqtt_username: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="store_mqtt_username"
          type="text"
          label="MQTT Username"
          placeholder="MQTT Username"
          className="custom"
          value={props.value}
          onError={onError}
          disabled
          required={props.required}
        />
      )
    },
    "ui:options": {
      label: false
    }
  },
  store_mqtt_password: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="store_mqtt_password"
          type="text"
          label="MQTT Password"
          placeholder="MQTT Password"
          className="custom"
          value={props.value}
          onError={onError}
          disabled
          required={props.required}
        />
      )
    },
    "ui:options": {
      label: false
    }
  },
  store_mqtt_mode: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="store_mqtt_mode"
          type="text"
          label="MQTT Mode"
          className="custom"
          value={props.value}
          onError={onError}
          disabled
          required={props.required}
        />
      )
    },
    "ui:options": {
      label: false
    }
  },
  store_mqtt_details: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="store_mqtt_details"
          type="text"
          label="MQTT Details"
          className="custom"
          value={stringify(props.value)}
          onError={onError}
          disabled
          required={props.required}
        />
      )
    },
    "ui:options": {
      label: false
    }
  }
};

class Example extends Component {
  constructor(props) {
    super(props)
    const deviceId = safeDeepGet(this, ['props', 'match', 'params', 'id']);
    this.state = {
      value: [],
      formData: {},
      values: '',
      deviceId,
      loading: true,
      prevPath: ''
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const _this = this
    const _props = _this.props
    const deviceId = safeDeepGet(_props, ['match', 'params', 'id']);
    if (isEmpty(deviceId)) {
      return {}
    }
    const wsKey = WKEY + '_' + deviceId;
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        wparam: { ...domainIsTenant, path: "/service/web/device/mqtt/node/get/id/" + deviceId },
        wcallback: {
          started: function (id) {
            // TODO Loading
          },
          finished: function (id, result) {
            // TODO Loading
            _this.setState({
              loading: false
            })
          },
        }
      }
    );
    _props.wSetConfig({
      single_config: {
        [EDIT]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/device/edit"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({
                    loading: false
                  })
                  _props.history.push('..' + S + '..' + S + '_device_list_')
                  _props.showSingleNotification({ message: 'Edit Perangkat Sukses', level: 'success' });
                  return;
                }
              }
              _this.setState({
                loading: false
              })
              _props.showSingleNotification({ message: 'Edit Perangkat Gagal', position: 'tr', level: 'error' });
            }
          }
        }
      }
    });
  }

  componentWillUnmount() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { deviceId } = _state;
    if (isEmpty(deviceId)) {
      return {}
    }
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }

  componentWillReceiveProps(nextProps) {
    const _this = this
    const _props = _this.props
    if (nextProps.location !== _props.location) {
      _this.setState({ prevPath: _props.location })
    }
  }

  handleSubmit(event) {
    const _this = this
    const _props = _this.props
    let submitData = event['formData'];
    const label = submitData['label'];
    const id = _props.deviceId;
    let action = setDevicePayload(submitData);
    _this.setState({
      formData: submitData
    })
    store.dispatch(action)
    _this.setState({
      loading: true
    })
    const wsKey = WKEY + '_' + id;
    _props.wSingleRequestCall({
      id: EDIT,
      body: {
        id,
        label
      }
    });
  }

  goTo(link) {
    this.props.history.push(link)
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const data = safeDeepGetWithType(_props, ['device'], {});
    let dataToShow = data;
    const { loading } = _state;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    return (
      <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
        <div className="view">
          <SubViewHeader title='Info MQTT' />
          <div className="io-container mt-12">
            <IoteraForm
              schema={schema}
              uiSchema={uiSchema}
              onSubmit={_this.handleSubmit}
              formData={dataToShow}
            >
              <div className="button-right" style={{ marginTop: 10 }}>

                <button className="button-iotera-white" type="button" style={{ minWidth: '0%' }}
                  onClick={(e) => _this.goTo('..' + S + '..' + S + '..' + S + '_device_list_')} >Kembali</button>
              </div>
            </IoteraForm>
          </div>
        </div>
      </Loader>
    );
  }
}

const mapStateToProps = function (state, ownProps) {
  return {
    device: wSelector.getSoleInitMappedRPayload(state),
    deviceId: wSelector.getSoleInitMappedRPayload(state, 'id')
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Example));